import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { UserFilters } from "../../types/filter";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

interface Props {
    filters: UserFilters;
    setFilters: Dispatch<SetStateAction<UserFilters>>;
    triggerFetch: any;
}

export function FilterUsersList({ filters, setFilters, triggerFetch }: Props) {
    const filtros = {
        nombre: "",
        rol: "",
        status: "",
    }

    const onFilterChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });
    }

    const cleanFilters = () => {
        setFilters(filtros);
        triggerFetch(filtros);
    }

    const disbleCleanFilters = JSON.stringify(filters) === JSON.stringify(filtros);

    return (
        <div className="flex flex-col gap-y-2 my-1 w-full">

            <div className="w-full mx-2 h-auto flex grow-0 items-center gap-x-1 justify-">
                <SearchRoundedIcon sx={{ height: 25, width: 25 }}/>
                <input 
                    value={filters.nombre}
                    className="border-gray-300 border-2 rounded text-gray-600 w-11/12 px-3 focus:font-semibold"
                    placeholder="Buscar nombre de usuario..."
                    autoComplete="off"
                    onChange={onFilterChange}
                    name="nombre"
                    type="text" />
                
                <button 
                    onClick={() => triggerFetch(filters)}
                    className="bg-green-800 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center disabled:opacity-50 w-[120px]">
                    <p className="text-white text-[13px] font-semibold text-center w-full">Aplicar filtros</p>
                </button>
            </div>

            <div className="border-0 border-green-500 mx-2 h-auto flex grow-0 items-center gap-x-3 justify-between w-full">
                <div className="flex grow-0 items-center gap-x-3">
                    <label className="font-semibold text-gray-600 text-sm">Rol: </label>
                    <select 
                        value={filters.rol}
                        onChange={onFilterChange}
                        className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                        name="rol">
                        <option hidden value="">Seleccionar rol</option>
                        <option value="">Todos los roles</option>
                        <option value="Administrador">Administrador</option>
                        <option value="Prospectador">Prospectador</option>
                        <option value="Vendedor">Vendedor</option>
                    </select>

                    <label className="font-semibold text-gray-600 text-sm">Estado: </label>
                    <select 
                        value={filters.status}
                        onChange={onFilterChange}
                        className="border-2 border-gray-300 rounded text-sm font-semibold text-gray-600"
                        name="status">
                        <option hidden value="">Seleccionar estado</option>
                        <option value="">Todos los estados</option>
                        <option value="Activo">Activo</option>
                        <option value="Inactivo">Inactivo</option>
                    </select>
                </div>

                <button 
                    onClick={cleanFilters}
                    disabled={disbleCleanFilters}
                    className="bg-blue-900 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center disabled:opacity-50 w-[108px]">
                    <p className="text-white text-[13px] font-semibold text-center w-full">limpiar filtros</p>
                </button>
            </div>

        </div>
    );
}